// extracted by css-extract-rspack-plugin
export default {"BaseSettingsPage":"base-settings-page-module__BaseSettingsPage__KyHWTab"};